export default __webpack_public_path__ + "static/media/14_LeftToRightSquares_Left.b7bf4679.mp4";